import { CreateMessageFailure } from '@store/broadcast-messages/features/create-message/create-message-failure';
import { CreateMessageSuccess } from '@store/broadcast-messages/features/create-message/create-message-success';
import { GetMessages } from '@store/broadcast-messages/features/get-message/get-messages';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';
import { AxiosResponse } from 'axios';
import {
  ICreateBroadcastMessageRequest,
  ICreateBroadcastMessageResponse,
} from 'lingopractices-models/src/main';
import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { createDeferredAction } from '../../../common/actions';
import { httpRequestFactory } from '../../../common/http-request-factory';
import { HttpRequestMethod } from '../../../common/http-request-method';
import { MAIN_API } from '../../../common/path';

export class CreateMessage {
  static get action() {
    return createDeferredAction<ICreateBroadcastMessageRequest>('broadcastMessages/CREATE_MESSAGE');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.requests.createBroadcastMessagePending = true;
      return draft;
    };
  }

  static get saga() {
    return function* ({ payload, meta }: ReturnType<typeof CreateMessage.action>): SagaIterator {
      try {
        const response = CreateMessage.httpRequest.call(
          yield call(() => CreateMessage.httpRequest.generator(payload)),
        );

        const {
          data: { id },
        } = response;

        if (id) {
          yield put(CreateMessageSuccess.action());
          yield put(GetMessages.action(null));

          meta?.deferred.resolve();
        }
      } catch (e) {
        yield put(CreateMessageFailure.action());
        meta?.deferred.reject(e);
      }
    };
  }

  static get httpRequest() {
    return httpRequestFactory<
      AxiosResponse<ICreateBroadcastMessageResponse>,
      ICreateBroadcastMessageRequest
    >(MAIN_API.BROADCAST_MESSAGES, HttpRequestMethod.Post);
  }
}
